export const LAYER_INDEXES = Object.seal({
  main: 1,
  overlay: 2,
  text: 3,
  audio: 4,
} as const);

export type LayerName = keyof typeof LAYER_INDEXES;
export type LayerIndex = (typeof LAYER_INDEXES)[LayerName];
